const breakpoints = {
  breakSm: "480px",
  breakMd: "768px",
  breakLg: "1200px",
  breakXl: "2000px",
  maxPageWidth: "1400px",
  breakHome: "1030px",
};

export { breakpoints };
